<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ professional.id ? $t('professional.form.editTitle') : $t('professional.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="Name">
                    <span class="required">*</span> {{ $t('professional.form.nameLabel') }}
                  </label>
                  <input
                    autocomplete="new-password"
                    type="text"
                    id="Name"
                    class="form-control"
                    v-model="professional.name"
                    placeholder=""
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="EmailDomain">{{ $t('professional.form.cboLabel') }}</label>
                  <v-select
                    :options="cbos"
                    :reduce="(cbos) => cbos.id"
                    :label="'cbo_name'"
                    v-model="professional.cbo_id"
                    class="vselect"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="inputUser">
                    <span class="required">*</span> {{ $t('common.status') }}:
                  </label>
                  <select v-model="professional.status" class="form-control">
                    <option :value="1">{{ $t('common.active') }}</option>
                    <option :value="0">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label> {{ $t('professional.form.phoneLabel') }}</label>
                  <input
                    v-model="professional.phone"
                    type="text"
                    class="form-control"
                    v-mask="'(99) 99999-9999'"
                  />
                </div>
              </div>

              <div v-if="cboFields.length" class="mb-1">
                <p class="font-weight-bold mb-1">
                  {{ $t('fieldSchema.professionalTitle') }} <em>{{ selectedCboName }}</em>
                </p>
                <DynamicMetadataFields
                  :schema="cboFields"
                  :value="professional.metadata"
                  @input="professional.metadata = $event"
                />
              </div>

              <div v-if="!professional.id" class="form-row">
                <div class="col-md-12">
                  <b-form-checkbox
                    v-model="professional.create_user"
                    switch
                  >
                    {{ $t('professional.form.createUserLabel') }}
                  </b-form-checkbox>
                  <small class="text-muted d-block mb-1">
                    {{ $t('professional.form.createUserHint') }}
                  </small>
                </div>
              </div>

              <div v-if="!professional.id && professional.create_user" class="form-row">
                <div class="form-group col-md-4">
                  <label><span class="required">*</span> {{ $t('professional.form.accessLevelLabel') }}</label>
                  <select v-model="professional.access_nivel" class="form-control">
                    <option :value="3">{{ $t('professional.form.accessLevelStandard') }}</option>
                    <option :value="2">{{ $t('professional.form.accessLevelManager') }}</option>
                    <option
                      v-if="$store.state.user.access_nivel == 1"
                      :value="1"
                    >
                      {{ $t('professional.form.accessLevelAdmin') }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label><span class="required">*</span> {{ $t('professional.form.passwordLabel') }}</label>
                  <input
                    v-model="professional.password"
                    type="password"
                    class="form-control"
                    autocomplete="new-password"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary mt-50"
                    @click="professional.password = 'Mudar123'"
                  >
                    {{ $t('professional.form.generateDefaultPassword') }}
                  </button>
                </div>
                <div class="form-group col-md-4">
                  <label>{{ $t('professional.form.photoLabel') }}</label>
                  <div class="user-img mb-1">
                    <img v-if="previewImage" :src="previewImage" class="photo" />
                  </div>
                  <input
                    id="professionalUserPic"
                    type="file"
                    accept="image/*"
                    @change="uploadImage"
                  />
                </div>
              </div>

              <span class="required_fields">
                <span class="required">*</span>
                <strong>{{ $t('professional.form.requiredFields') }}</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link to="/professionals" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                </router-link>
                <a v-if="$hasAbility('profissional.gerenciar')" class="btn btn-add ml-1" @click="save">
                  {{ $t('common.save') }}
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import DynamicMetadataFields from "@/components/DynamicMetadataFields.vue";

export default {
  name: "imageUpload",
  data() {
    return {
      professional: {
        cbo_id: null,
        metadata: {},
        name: "",
        requester_id: null,
        phone: "",
        status: "1",
        create_user: false,
        access_nivel: 3,
        password: "",
      },
      cbos: [],
      previewImage: null,
    };
  },
  computed: {
    selectedCbo() {
      return this.cbos.find((c) => c.id === this.professional.cbo_id) || null;
    },
    cboFields() {
      const schema = this.selectedCbo && this.selectedCbo.field_schema;
      return Array.isArray(schema) ? schema : [];
    },
    selectedCboName() {
      return this.selectedCbo ? this.selectedCbo.cbo_name : "";
    },
  },
  methods: {
    uploadImage(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (ev) => {
        this.previewImage = ev.target.result;
      };
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "professionals";

      const fd = new FormData();
      fd.append("name", self.professional.name || "");
      fd.append("cbo_id", self.professional.cbo_id || "");
      fd.append("phone", self.professional.phone || "");
      fd.append("status", self.professional.status);

      // Só os campos do CBO escolhido; trocar de CBO descarta os do anterior.
      const metadata = self.professional.metadata || {};
      self.cboFields.forEach((f) => {
        const v = metadata[f.key];
        if (v !== undefined && v !== null && v !== "") {
          fd.append("metadata[" + f.key + "]", v);
        }
      });

      if (!self.professional.id && self.professional.create_user) {
        fd.append("create_user", "1");
        fd.append("access_nivel", self.professional.access_nivel);
        fd.append("password", self.professional.password || "");

        const photo = document.getElementById("professionalUserPic");
        if (photo && photo.files[0]) {
          fd.append("photo", photo.files[0]);
        }
      }

      if (self.professional.id) {
        api += "/" + self.professional.id;
        fd.append("_method", "PUT");
      }

      self.$loading(true);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            self.$t('professional.messages.successTitle'),
            self.$t('professional.messages.saveSuccess'),
            "success",
          );
          self.$loading(false);
          this.$router.push("/professionals");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCbo: function () {
      const self = this;
      let api = self.$store.state.api + "cbos?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.cbos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProfessional: function (id) {
      const self = this;
      const api = self.$store.state.api + "professionals/" + id;
      self.$loading(true);

      self.$http
        .get(api)
        .then((response) => {
          self.professional = response.data.data[0];
          self.professional.metadata = self.professional.metadata || {};
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getCbo();

    if (id) {
      self.getProfessional(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
    DynamicMetadataFields,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
